import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import NotesAndQueriesList from "@/components/lists/notes/NotesAndQueriesList";
import TrialContext from "@/contexts/data/TrialContext";
import { NotesAndQueriesInstitutionCreateLink, NotesAndQueriesParticipantCreateLink, NotesAndQueriesTrialCreateLink } from "@/contexts/layouts/LinkContext";
import useTrialNotesAndQueries from "@/hooks/data/useTrialNotesAndQueries";
import { Typography } from "@mui/material";
import { FC, useContext } from "react";

const TrialNotesAndQueries: FC = () => {
    const { data: trial } = useContext(TrialContext);
    const { data: notes, loading: notesLoading, validating: notesValidating } = useTrialNotesAndQueries(trial?.id, { revalidateOnFocus: false });


    const loading = notesLoading;
    const validating = notesValidating;

    return (
        <>
            <SetLinks 
                createTrialLink={NotesAndQueriesTrialCreateLink} 
                createInstitutionLink={NotesAndQueriesInstitutionCreateLink} 
                createParticipantLink={NotesAndQueriesParticipantCreateLink}  
            />
            <IsLoading name="trial-notes-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Notes And Queries
                </Typography>
                <NotesAndQueriesList trialId={trial?.id} notesAndQueries={notes} />
            </Show>
        </>
    )
};

export default TrialNotesAndQueries;